<hb-modal-dialog heading="{{ 'FailureDataLibraryDialog.Title' | i18next }}" [okDisabled]="!foundModel()" (okClicked)="confirmLoad()">
  <div content>
    <div *ngIf="dataLoadService" class="form-container">
      <form [formGroup]="formGroup">
        <hb-iso-hierarchy-query [formGroup]="formGroup" [selectionService]="dataLoadService"></hb-iso-hierarchy-query>

        <hb-df-textbox [control]="modelNameControl" [formGroup]="formGroup"></hb-df-textbox>
      </form>
    </div>
  </div>
</hb-modal-dialog>
